import * as Mui from "@mui/material";
import { useContext, useMemo, useState } from "react";
import { useTranslation } from "react-i18next";
import { ContextOperation } from "../../../context/OperationContext";
import useOperationTranslation from "../../../hooks/useOperationTranslation";
import DriversType from "../../../types/DriversType";
// import LocationsByBpCodesType from "../../../types/LocationsByBpCodesType";
import FormInput from "../../common/FormInput";
import DeliveryNoteService from "../service/DeliveryNoteServices";

interface Props {
  drivers?: DriversType[];
  externalDriver: string;
}

export const DriverDetails = (props: Props) => {
  const t = useOperationTranslation();
  const { i18n } = useTranslation();
  const { tenant } = useContext(ContextOperation);
  // const [getDataFromLocationsByBpCodes, setGetDataFromLocationsByBpCodes] =
  //   useState<LocationsByBpCodesType>();

  const addType = (type: string) => {
    switch (type) {
      case "PARKING_GO":
        return t("internOptionSelectName.physicalLocationType.parkingGo");
      case "LMS":
        return t("internOptionSelectName.physicalLocationType.lms");
      case "COMPOUND":
        return t("internOptionSelectName.physicalLocationType.compound");
      case "SHOP_REPAIR":
        return t("internOptionSelectName.physicalLocationType.shopRepair");
      default:
        return "";
    }
  };

  // useMemo(() => {
  //   if (props.drivers?.length === 0) {
  //     DeliveryNoteService.get
  //       .locationsByBpCodes(tenant, props.externalDriver)
  //       .then((response: any) => {
  //         setGetDataFromLocationsByBpCodes({
  //           ...response,
  //           type: addType(response.type),
  //         });
  //       });
  //   }
  // }, [i18n.language]);

  return (
    <>
      {props.drivers?.length !== 0 ? (
        <>
          {props.drivers?.map((driver: any, index: number) => {
            return (
              <Mui.Box key={`driver-box-${index}`} mb={2}>
                <Mui.Card key={`driver-card-${index}`}>
                  <Mui.CardContent key={`driver-card-content-${index}`}>
                    <Mui.Grid
                      container
                      key={`driver-grid-content-${index}`}
                      columns={12}
                      alignItems="center"
                      spacing={2.5}
                      rowGap={4}
                    >
                      {/*----------------------------------------- 1 row -------------------------------------- */}

                      <Mui.Grid item xs={12} sm={12} md={6} lg={3} xl={3}>
                        <FormInput
                          name="name"
                          label={t(
                            "deliveryNote.deliveryDetails.tab.drivers.name"
                          )}
                          value={driver?.name || ""}
                          type="text"
                          disabled
                          fullWidth
                        />
                      </Mui.Grid>

                      <Mui.Grid item xs={12} sm={12} md={6} lg={3} xl={3}>
                        <FormInput
                          name="surname"
                          label={t(
                            "deliveryNote.deliveryDetails.tab.drivers.surname"
                          )}
                          value={driver?.surname || ""}
                          type="text"
                          disabled
                          fullWidth
                        />
                      </Mui.Grid>

                      <Mui.Grid item xs={12} sm={12} md={6} lg={3} xl={3}>
                        <FormInput
                          name="address"
                          label={t(
                            "deliveryNote.deliveryDetails.tab.drivers.address"
                          )}
                          value={driver?.address || ""}
                          type="text"
                          disabled
                          fullWidth
                        />
                      </Mui.Grid>

                      <Mui.Grid item xs={12} sm={12} md={6} lg={3} xl={3}>
                        <FormInput
                          name="birthDate"
                          label={t(
                            "deliveryNote.deliveryDetails.tab.drivers.birthDate"
                          )}
                          value={driver?.birthDate || ""}
                          type="date"
                          disabled
                          fullWidth
                        />
                      </Mui.Grid>
                      {/*----------------------------------------- 2 row -------------------------------------- */}
                      <Mui.Grid item xs={12} sm={12} md={6} lg={3} xl={3}>
                        <FormInput
                          name="birthNation"
                          label={t(
                            "deliveryNote.deliveryDetails.tab.drivers.birthNation"
                          )}
                          value={driver?.birthNation || ""}
                          type="text"
                          disabled
                          fullWidth
                        />
                      </Mui.Grid>

                      <Mui.Grid item xs={12} sm={12} md={6} lg={3} xl={3}>
                        <FormInput
                          name="countryResidence"
                          label={t(
                            "deliveryNote.deliveryDetails.tab.drivers.countryResidence"
                          )}
                          value={driver?.countryResidence || ""}
                          type="text"
                          disabled
                          fullWidth
                        />
                      </Mui.Grid>

                      <Mui.Grid item xs={12} sm={12} md={6} lg={3} xl={3}>
                        <FormInput
                          name="residenceAddress"
                          label={t(
                            "deliveryNote.deliveryDetails.tab.drivers.residenceAddress"
                          )}
                          value={driver?.residenceAddress || ""}
                          type="text"
                          disabled
                          fullWidth
                        />
                      </Mui.Grid>

                      {/*----------------------------------------- 3 row -------------------------------------- */}

                      <Mui.Grid item xs={12} sm={12} md={6} lg={3} xl={3}>
                        <FormInput
                          name="fiscalCode"
                          label={t(
                            "deliveryNote.deliveryDetails.tab.drivers.fiscalCode"
                          )}
                          value={driver?.fiscalCode || ""}
                          type="text"
                          disabled
                          fullWidth
                        />
                      </Mui.Grid>

                      <Mui.Grid item xs={12} sm={12} md={6} lg={3} xl={3}>
                        <FormInput
                          name="drivingLicenseNumber"
                          label={t(
                            "deliveryNote.deliveryDetails.tab.drivers.drivingLicenseNumber"
                          )}
                          value={driver?.drivingLicenseNumber || ""}
                          type="text"
                          disabled
                          fullWidth
                        />
                      </Mui.Grid>

                      <Mui.Grid item xs={12} sm={12} md={6} lg={3} xl={3}>
                        <FormInput
                          name="mobile"
                          label={t(
                            "deliveryNote.deliveryDetails.tab.drivers.mobile"
                          )}
                          value={driver?.mobile || ""}
                          type="text"
                          disabled
                          fullWidth
                        />
                      </Mui.Grid>
                    </Mui.Grid>
                  </Mui.CardContent>
                </Mui.Card>
              </Mui.Box>
            );
          })}
        </>
      ) : (
        <Mui.Box textAlign={"center"}>
          <Mui.Typography variant="h6">
            {t("deliveryNote.deliveryDetails.tab.drivers.noDriver")}
          </Mui.Typography>
        </Mui.Box>
      )}
    </>
  );
};
